import { Injectable, computed, signal } from '@angular/core';
import {
  DESK_LANG_KEY,
  DeskLang,
  ROLE_DESK_COPY,
  RoleDeskCopy,
  readDeskLang,
} from '../i18n/role-desk.i18n';

@Injectable({ providedIn: 'root' })
export class DeskLangService {
  readonly lang = signal<DeskLang>(readDeskLang());

  readonly copy = computed((): RoleDeskCopy => ROLE_DESK_COPY[this.lang()]);

  setLang(next: DeskLang): void {
    this.lang.set(next);
    try {
      localStorage.setItem(DESK_LANG_KEY, next);
    } catch {
      /* ignore */
    }
    document.documentElement.lang = next === 'hi' ? 'hi' : 'en';
  }

  toggleLang(): void {
    this.setLang(this.lang() === 'en' ? 'hi' : 'en');
  }
}
